import { render, staticRenderFns } from "./OrderCertificate.vue?vue&type=template&id=2a09b435&scoped=true&"
import script from "./OrderCertificate.vue?vue&type=script&lang=js&"
export * from "./OrderCertificate.vue?vue&type=script&lang=js&"
import style0 from "./OrderCertificate.vue?vue&type=style&index=0&id=2a09b435&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a09b435",
  null
  
)

export default component.exports